const MODULE = document.querySelectorAll('[data-module="noticias"]');

class Noticias {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {
        });
    }
}

(() => {
    if (MODULE) {
        new Noticias();
    }
})();

export default Noticias;